module.exports = __webpack_public_path__ + "img/digg-22072019.b7cdee60.png";